import React from 'react';

export interface AmountReceivedRow {
  id: string;
  date: string;
  chequeNo: string;
  fromBank: string;
  toBank: string;
  vessel: string;
  description: string;
  invoiceRef: string;
  paidUSD: number;
  paidEGP: number;
  actualUSD: number;
  actualRate: number;
  actualEGP: number;
}

interface BankOption {
  value: string;
  label: string;
}

interface InvoiceAmountReceivedSectionProps {
  rows: AmountReceivedRow[];
  onAddRow: () => void;
  onUpdateRow: (id: string, field: string, value: any) => void;
  onRemoveRow: (id: string) => void;
  bankOptions?: BankOption[];
}

const InvoiceAmountReceivedSection: React.FC<InvoiceAmountReceivedSectionProps> = ({
  rows,
  onAddRow,
  onUpdateRow,
  onRemoveRow,
  bankOptions = [],
}) => {
  return (
    <div className="border-t pt-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium text-gray-900">Amount Received</h3>
        <button
          type="button"
          onClick={onAddRow}
          className="px-4 py-2 bg-green-600 text-white text-sm rounded-md hover:bg-green-700"
        >
          + Add Payment
        </button>
      </div>

      {rows.length > 0 && (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300 text-xs">
            <thead>
              <tr className="bg-gray-100">
                <th className="px-2 py-2 border-b font-medium">Date</th>
                <th className="px-2 py-2 border-b font-medium">Cheque No.</th>
                <th className="px-2 py-2 border-b font-medium">From Bank</th>
                <th className="px-2 py-2 border-b font-medium">To Bank</th>
                <th className="px-2 py-2 border-b font-medium">Vessel</th>
                <th className="px-2 py-2 border-b font-medium">Description</th>
                <th className="px-2 py-2 border-b font-medium">Invoice</th>
                <th className="px-2 py-2 border-b font-medium">Paid USD</th>
                <th className="px-2 py-2 border-b font-medium">Paid EGP</th>
                <th className="px-2 py-2 border-b bg-green-50 font-medium">USD</th>
                <th className="px-2 py-2 border-b bg-green-50 font-medium">Rate</th>
                <th className="px-2 py-2 border-b bg-green-50 font-medium">EGP</th>
                <th className="px-2 py-2 border-b font-medium">Action</th>
              </tr>
              <tr className="bg-gray-50">
                <th colSpan={9} className="px-2 py-1 border-b text-left text-xs text-gray-600">Amount Received</th>
                <th colSpan={3} className="px-2 py-1 border-b text-center text-xs text-gray-600 bg-green-50">The actual value of the check/Transfer</th>
                <th className="px-2 py-1 border-b"></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td className="px-1 py-1 border-b">
                    <input type="date" value={row.date} onChange={(e) => onUpdateRow(row.id, 'date', e.target.value)} className="w-28 px-1 py-1 border rounded text-xs" />
                  </td>
                  <td className="px-1 py-1 border-b">
                    <input type="text" value={row.chequeNo} onChange={(e) => onUpdateRow(row.id, 'chequeNo', e.target.value)} className="w-20 px-1 py-1 border rounded text-xs" placeholder="No." />
                  </td>
                  <td className="px-1 py-1 border-b">
                    <input type="text" value={row.fromBank} onChange={(e) => onUpdateRow(row.id, 'fromBank', e.target.value)} className="w-20 px-1 py-1 border rounded text-xs" placeholder="Bank" />
                  </td>
                  <td className="px-1 py-1 border-b">
                    <select value={row.toBank} onChange={(e) => onUpdateRow(row.id, 'toBank', e.target.value)} className="w-32 px-1 py-1 border rounded text-xs bg-white">
                      <option value="">Select bank</option>
                      {bankOptions.map((bank) => (
                        <option key={bank.value} value={bank.value}>{bank.label}</option>
                      ))}
                    </select>
                  </td>
                  <td className="px-1 py-1 border-b">
                    <input type="text" value={row.vessel} onChange={(e) => onUpdateRow(row.id, 'vessel', e.target.value)} className="w-20 px-1 py-1 border rounded text-xs" placeholder="Vessel" />
                  </td>
                  <td className="px-1 py-1 border-b">
                    <input type="text" value={row.description} onChange={(e) => onUpdateRow(row.id, 'description', e.target.value)} className="w-28 px-1 py-1 border rounded text-xs" placeholder="Desc" />
                  </td>
                  <td className="px-1 py-1 border-b">
                    <input type="text" value={row.invoiceRef} onChange={(e) => onUpdateRow(row.id, 'invoiceRef', e.target.value)} className="w-24 px-1 py-1 border rounded text-xs" placeholder="Inv#" />
                  </td>
                  <td className="px-1 py-1 border-b">
                    <input type="number" step="0.01" value={row.paidUSD || ''} onChange={(e) => onUpdateRow(row.id, 'paidUSD', parseFloat(e.target.value) || 0)} className="w-24 px-1 py-1 border rounded text-xs" placeholder="0.00" />
                  </td>
                  <td className="px-1 py-1 border-b">
                    <input type="number" step="0.01" value={row.paidEGP || ''} onChange={(e) => onUpdateRow(row.id, 'paidEGP', parseFloat(e.target.value) || 0)} className="w-24 px-1 py-1 border rounded text-xs" placeholder="0.00" />
                  </td>
                  <td className="px-1 py-1 border-b bg-green-50">
                    <input type="number" step="0.01" value={row.actualUSD || ''} onChange={(e) => onUpdateRow(row.id, 'actualUSD', parseFloat(e.target.value) || 0)} className="w-24 px-1 py-1 border rounded text-xs" placeholder="0.00" />
                  </td>
                  <td className="px-1 py-1 border-b bg-green-50">
                    <input type="number" step="0.01" value={row.actualRate || ''} onChange={(e) => onUpdateRow(row.id, 'actualRate', parseFloat(e.target.value) || 0)} className="w-16 px-1 py-1 border rounded text-xs" placeholder="Rate" />
                  </td>
                  <td className="px-1 py-1 border-b bg-green-50 text-center font-medium">
                    {Number(row.actualEGP || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                  </td>
                  <td className="px-1 py-1 border-b text-center">
                    <button type="button" onClick={() => onRemoveRow(row.id)} className="text-red-600 hover:text-red-800 text-xs">X</button>
                  </td>
                </tr>
              ))}
            </tbody>
            {rows.length > 0 && (
              <tfoot>
                <tr className="bg-gray-50 font-medium text-xs">
                  <td colSpan={7} className="px-2 py-2 border-t text-right">Totals:</td>
                  <td className="px-2 py-2 border-t text-center">{rows.reduce((s, r) => s + (r.paidUSD || 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                  <td className="px-2 py-2 border-t text-center">{rows.reduce((s, r) => s + (r.paidEGP || 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                  <td className="px-2 py-2 border-t bg-green-50 text-center">{rows.reduce((s, r) => s + (r.actualUSD || 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                  <td className="px-2 py-2 border-t bg-green-50"></td>
                  <td className="px-2 py-2 border-t bg-green-50 text-center">{rows.reduce((s, r) => s + (r.actualEGP || 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                  <td className="px-2 py-2 border-t"></td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      )}

      {rows.length === 0 && (
        <p className="text-sm text-gray-500 italic">No payments recorded. Click "Add Payment" to track received amounts.</p>
      )}
    </div>
  );
};

export default InvoiceAmountReceivedSection;
